module.exports = __webpack_public_path__ + "static/img/psi-logo-white.498f987.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/psi-logo-white.svg
// module id = F6o3
// module chunks = 1